import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function LightningIcon(props: SvgIconProps) {
  const fill = props.stroke ?? props.fill ?? props.color ?? '#3B3C40';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
      fill='none'
      stroke='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.5137 0.499156C15.9611 0.72879 16.2018 1.22751 16.1032 1.72067L14.7908 8.28258L19.895 10.1967C20.2467 10.3286 20.5094 10.6273 20.5952 10.993C20.6811 11.3586 20.5787 11.743 20.3225 12.0176L9.82245 23.2676C9.4793 23.6353 8.93379 23.7306 8.48635 23.5009C8.03891 23.2713 7.79823 22.7726 7.89686 22.2794L9.20925 15.7175L4.105 13.8034C3.7533 13.6715 3.49062 13.3728 3.40478 13.0071C3.31895 12.6414 3.42129 12.257 3.67758 11.9824L14.1776 0.732433C14.5207 0.364763 15.0662 0.269522 15.5137 0.499156ZM6.47059 12.2875L10.895 13.9467C11.4115 14.1403 11.7113 14.6798 11.6032 15.2207L10.8799 18.8371L17.5294 11.7126L13.105 10.0534C12.5886 9.85975 12.2887 9.32025 12.3969 8.77941L13.1202 5.16297L6.47059 12.2875Z'
        fill={fill}
      />
    </SvgIcon>
  );
}
